import { map } from 'lodash';
import { stringValue } from 'vega-lib';
import { generateVegaLabelTextExpression } from 'utils/chart/vega-expressions';

/**
 * small helper function to replace the 'color' channel with the word 'series'
 * for the tooltips.
 *
 * @param  {String} field    input field name
 * @return {String}          resulting field name
 */
function changeColorToSeries(field) {
  return field === 'color' ? 'series' : field;
}

/**
 * builds a stringified object for Vega specs to be used for the tooltip
 * mark property.
 *
 * @param  {Object} encodings       the encoding channels
 * @param  {Object} customisations  customisations object
 * @return {String}                 a stringified JavaScript object where the
 *                                  key is the original encoded field and the
 *                                  value is datum["channel"] for the encoded
 *                                  channel.
 */
export function generateVegaTooltip(encodings, customisations) {
  const parsedFields = [];

  const result = map(encodings, (enc, channel) => {
    const field = changeColorToSeries(enc.axis.title);

    if (!parsedFields.includes(field)) {
      // Add the field to the parsedFields array so we don't return duplicate fields for the tooltip
      // which would result in a Vega parseError
      parsedFields.push(field);

      const channelCustoms = customisations.channels[channel];
      const value = generateVegaLabelTextExpression(enc, channelCustoms, {
        field: channel,
      });
      return `${stringValue(field)}: ${value}`;
    }
  })
    .filter(n => n)
    .join(',');

  return `{${result}}`;
}
